import { useNavigate } from "react-router-dom";

import { JourneyDetails } from "modules/personalisation/components/JourneyDetails";
import { usePersonalisationData } from "modules/personalisation/context/PersonalisationDataContext";
import { usePersonalisationLeave } from "modules/personalisation/context/PersonalisationLeaveContext";

import { PickYourJourneyContainer_PATH } from "./PickYourJourneyContainer";
import { YouAreNotAloneContainer_PATH } from "./YouAreNotAloneContainer";

export const JourneyDetailsContainer_PATH = "/personalise/journey-details" as const;

export function JourneyDetailsContainer() {
  const navigate = useNavigate();
  const { setJourneyDetailsAnswered, skipJourneyDetails, journeyDetails } =
    usePersonalisationData();
  const { openConfirmLeave } = usePersonalisationLeave();

  return (
    <JourneyDetails
      progressPercentage={20}
      onContinue={(text) => {
        setJourneyDetailsAnswered(text);
        navigate(YouAreNotAloneContainer_PATH);
      }}
      onBack={() => {
        navigate(PickYourJourneyContainer_PATH);
      }}
      onSkip={() => {
        skipJourneyDetails();
        navigate(YouAreNotAloneContainer_PATH);
      }}
      onClose={openConfirmLeave}
      initialText={journeyDetails.state === "answered" ? journeyDetails.value : undefined}
    />
  );
}
